 // ============================================
// ELITE BALLER — THEME JS
// ============================================

document.addEventListener('DOMContentLoaded', function () {

  // ── Sticky Header Shadow ──
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('scrolled', window.scrollY > 20);
    });
  }

  // ── Mobile Nav ──
  var hamburger = document.querySelector('.hamburger');
  var mobileNav = document.getElementById('mobile-nav');
  var mobileClose = document.getElementById('mobile-nav-close');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.add('open');
      document.body.style.overflow = 'hidden';
    });
  }
  if (mobileClose && mobileNav) {
    mobileClose.addEventListener('click', function () {
      mobileNav.classList.remove('open');
      document.body.style.overflow = '';
    });
  }
  if (mobileNav) {
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  // ── Scroll Fade-In ──
  var fadeEls = document.querySelectorAll('.fade-in');
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });
    fadeEls.forEach(function (el) { observer.observe(el); });
  } else {
    fadeEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // ── Product Image Gallery ──
  function switchGalleryImage(index) {
    var imgs   = document.querySelectorAll('.gallery-main-img');
    var thumbs = document.querySelectorAll('.gallery-thumb');
    var dots   = document.querySelectorAll('.gallery-dot');
    imgs.forEach(function(img) { img.classList.remove('active'); });
    thumbs.forEach(function(t) { t.classList.remove('active'); });
    dots.forEach(function(d) { d.classList.remove('active'); });
    if (imgs[index])   imgs[index].classList.add('active');
    if (thumbs[index]) thumbs[index].classList.add('active');
    if (dots[index])   dots[index].classList.add('active');
  }

  // Thumbnail clicks (desktop)
  document.querySelectorAll('.gallery-thumb').forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      switchGalleryImage(parseInt(this.dataset.index));
    });
  });

  // Dot clicks (mobile)
  document.querySelectorAll('.gallery-dot').forEach(function(dot) {
    dot.addEventListener('click', function() {
      switchGalleryImage(parseInt(this.dataset.index));
    });
  });

  // Touch swipe on the main image (mobile)
  var galleryMain = document.getElementById('gallery-main');
  if (galleryMain) {
    var touchStartX = 0;
    var totalImgs = document.querySelectorAll('.gallery-main-img').length;
    galleryMain.addEventListener('touchstart', function(e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });
    galleryMain.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      var active = document.querySelector('.gallery-main-img.active');
      var cur = active ? parseInt(active.dataset.index) : 0;
      switchGalleryImage(diff > 0
        ? Math.min(cur + 1, totalImgs - 1)
        : Math.max(cur - 1, 0));
    }, { passive: true });
  }

  // ── Size / Variant Selector ──
  var variantData = [];
  var variantSelect = document.querySelector('select[name="id"]');

  if (variantSelect) {
    variantSelect.querySelectorAll('option').forEach(function (opt) {
      if (opt.dataset.options) {
        variantData.push({
          id: opt.value,
          options: JSON.parse(opt.dataset.options),
          available: opt.dataset.available !== 'false'
        });
      }
    });
  }

  function getSelectedOptions() {
    var selected = {};
    document.querySelectorAll('.size-options').forEach(function (group) {
      var active = group.querySelector('.size-btn.active');
      if (active) selected[group.dataset.option] = active.getAttribute('data-value');
    });
    return selected;
  }

  function findMatchingVariant(selectedOptions) {
    var keys = Object.keys(selectedOptions);
    if (!keys.length) return null;
    for (var i = 0; i < variantData.length; i++) {
      var v = variantData[i];
      if (keys.every(function (k) { return v.options && v.options[k] === selectedOptions[k]; })) return v;
    }
    return null;
  }

  document.querySelectorAll('.size-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      this.closest('.size-options').querySelectorAll('.size-btn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');

      if (variantData.length > 0) {
        var variant = findMatchingVariant(getSelectedOptions());
        if (variant && variantSelect) {
          variantSelect.value = variant.id;
          var addBtn = document.querySelector('.add-to-cart');
          if (addBtn) {
            addBtn.disabled = !variant.available;
            addBtn.textContent = variant.available ? 'Add to Bag' : 'Sold Out';
          }
          var selectedOpt = variantSelect.querySelector('option[value="' + variant.id + '"]');
          if (selectedOpt) {
            var imgIdx = parseInt(selectedOpt.dataset.imageIndex);
            if (!isNaN(imgIdx) && imgIdx >= 0) switchGalleryImage(imgIdx);
          }
        }
      } else {
        var sel = document.querySelector('select[name="id"]');
        if (sel) {
          var val = this.getAttribute('data-value');
          for (var i = 0; i < sel.options.length; i++) {
            if (sel.options[i].text.indexOf(val) !== -1) { sel.selectedIndex = i; break; }
          }
        }
      }
    });
  });

  document.querySelectorAll('.size-options').forEach(function (group) {
    var first = group.querySelector('.size-btn');
    if (first) first.classList.add('active');
  });

  // ── Ticker ──
  var ticker = document.querySelector('.ticker-track');
  if (ticker) ticker.innerHTML += ticker.innerHTML;

  // ============================================
  // CART DRAWER
  // ============================================

  var cartDrawer   = document.getElementById('cart-drawer');
  var cartOverlay  = document.getElementById('cart-overlay');
  var cartBody     = document.getElementById('cart-drawer-body');
  var cartFooter   = document.getElementById('cart-drawer-footer');
  var cartSubtotal = document.getElementById('cart-subtotal-amount');
  var drawerCount  = document.getElementById('cart-drawer-count');
  var drawerTrigger = document.getElementById('cart-drawer-trigger');
  var drawerClose  = document.getElementById('cart-drawer-close');

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function updateAllCartCounts(count) {
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = count; });
    if (drawerCount) drawerCount.textContent = '(' + count + ')';
  }

   window.openCartDrawer = function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    cartOverlay.classList.add('open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    fetchAndRenderCart();
  }

  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    cartOverlay.classList.remove('open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  if (drawerTrigger) drawerTrigger.addEventListener('click', openCartDrawer);
  if (drawerClose)   drawerClose.addEventListener('click', closeCartDrawer);
  if (cartOverlay)   cartOverlay.addEventListener('click', closeCartDrawer);

  // Close on Escape
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  function renderCart(cart) {
    if (!cartBody) return;

    updateAllCartCounts(cart.item_count);

    if (cart.item_count === 0) {
      cartBody.innerHTML =
        '<div class="cart-empty">' +
          '<p class="cart-empty-title">Your bag is empty.</p>' +
          '<p class="cart-empty-sub">Looks like you haven\'t added anything yet.</p>' +
          '<a href="/collections/all" class="cart-empty-shop" onclick="closeCartDrawerGlobal()">Shop the Collection →</a>' +
        '</div>';
      if (cartFooter) cartFooter.style.display = 'none';
      return;
    }

    var html = '';
    cart.items.forEach(function (item) {
      var imageUrl = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/(\.(jpg|jpeg|png|gif|webp))(\?|$)/, '_200x$1$3')
        : '';
      var variantTitle = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';

      html +=
        '<div class="cart-item" data-key="' + item.key + '">' +
          (imageUrl
            ? '<img class="cart-item-image" src="' + imageUrl + '" alt="' + item.product_title + '">'
            : '<div class="cart-item-image" style="background:var(--off-white);display:flex;align-items:center;justify-content:center;font-family:var(--font-display);font-size:22px;font-weight:900;color:var(--gray-light);">EB</div>') +
          '<div class="cart-item-info">' +
            '<p class="cart-item-title">' + item.product_title + '</p>' +
            (variantTitle ? '<p class="cart-item-variant">' + variantTitle + '</p>' : '') +
            '<p class="cart-item-price">' + formatMoney(item.line_price) + '</p>' +
            '<div class="cart-item-controls">' +
              '<button class="cart-qty-btn" data-key="' + item.key + '" data-action="decrease" aria-label="Decrease quantity">−</button>' +
              '<span class="cart-qty-display">' + item.quantity + '</span>' +
              '<button class="cart-qty-btn" data-key="' + item.key + '" data-action="increase" aria-label="Increase quantity">+</button>' +
              '<button class="cart-item-remove" data-key="' + item.key + '" aria-label="Remove item">Remove</button>' +
            '</div>' +
          '</div>' +
        '</div>';
    });

    cartBody.innerHTML = html;

    if (cartFooter) {
      cartFooter.style.display = 'block';
      if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    }

    // Quantity / remove handlers
    cartBody.querySelectorAll('.cart-qty-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = this.dataset.key;
        var action = this.dataset.action;
        var row = this.closest('.cart-item');
        var currentQty = parseInt(row.querySelector('.cart-qty-display').textContent);
        var newQty = action === 'increase' ? currentQty + 1 : Math.max(0, currentQty - 1);
        updateCartItem(key, newQty);
      });
    });

    cartBody.querySelectorAll('.cart-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        updateCartItem(this.dataset.key, 0);
      });
    });
  }

  function fetchAndRenderCart() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div style="padding:40px;text-align:center;font-family:var(--font-condensed);font-size:12px;letter-spacing:3px;text-transform:uppercase;color:var(--gray-mid);">Loading...</div>';
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {
        cartBody.innerHTML = '<div style="padding:40px;text-align:center;font-family:var(--font-body);font-size:14px;color:var(--gray-mid);">Could not load bag. Please try again.</div>';
      });
  }

  function updateCartItem(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(renderCart)
    .catch(function () { fetchAndRenderCart(); });
  }

  // ── Add to Cart — AJAX + open drawer ──
  var addToCartForm = document.querySelector('form[action="/cart/add"]');
  if (addToCartForm) {
    addToCartForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = this.querySelector('.add-to-cart');
      var formData = new FormData(this);
      var original = btn ? btn.textContent : '';
      if (btn) { btn.disabled = true; btn.textContent = 'Adding...'; }

      fetch('/cart/add.js', { method: 'POST', body: formData })
        .then(function (r) { return r.json(); })
        .then(function () {
          if (btn) {
            btn.textContent = '✓ Added';
            setTimeout(function () {
              btn.textContent = original;
              btn.disabled = false;
            }, 1800);
          }
          openCartDrawer();
        })
        .catch(function () {
          if (btn) { btn.textContent = original; btn.disabled = false; }
          addToCartForm.submit();
        });
    });
  }

  // Make close accessible globally for the empty-state link
  window.closeCartDrawerGlobal = closeCartDrawer;

});